export default class PrimeReact {

    static ripple = false;

    static locale = 'en';

    static zIndex = {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100
    }

    static appendTo = null;
}
